module.exports = __webpack_public_path__ + "1791188489487/fonts/line-awesome.452a5b4.woff2";